import { openPersonPage } from "@utils/navigation.util";
import { getFullNameOrEmail } from "@utils/tags.util";
import { IPeopleTagResponse } from "@interfaces/responses.interface";
import { CompanyAvatar, CompanyAvatarSizes } from "@ui/Avatars/CompanyAvatar";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: IPeopleTagResponse;
  isDisabled: boolean;
  onAdd?: (tag: IPeopleTagResponse) => void;
  onRemove?: (tag: IPeopleTagResponse) => void;
  withRedirect?: boolean;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function PeopleTag({
  data,
  isDisabled,
  onAdd,
  onRemove,
  withRedirect = false,
  withPlusIcon,
  iconOnly,
}: Props) {
  const displayName = getFullNameOrEmail(data.object);

  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() => {
        if (withRedirect) {
          openPersonPage(data.object.id);
        }
      }}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <CompanyAvatar
        classNames="rounded-full border flex-shrink-0 w-5 h-5"
        size={CompanyAvatarSizes.SMALL}
        userProps={data.object}
        logoUrl={data.object.logo}
        showInitialsByDefault
      />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{displayName}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
